<template>
  <div class="alipay">
    <div v-html="apply"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      apply: "",
    };
  },
  created() {
    let form = this.$route.query.htmls;
    this.apply = form;
  },
  mounted() {
    setTimeout(() => {
      document.forms[0].submit();
    }, 500);
  },
};
</script>


// WEBPACK FOOTER //
// src/view/pay/index.vue